import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const industriesData = [
    { id: 1, title: "Financial Services", image: "/assets/leverage/p1.png" },
    { id: 2, title: "eCommerce", image: "/assets/leverage/p2.png" },
    { id: 3, title: "Insurance", image: "/assets/leverage/p3.png" },
    { id: 4, title: "Manufacturing", image: "/assets/leverage/p4.png" },
    { id: 5, title: "Retail & Consumer Goods", image: "/assets/leverage/p5.png" },
    { id: 6, title: "Manufacturing", image: "/assets/leverage/p6.png" },
    { id: 7, title: "Manufacturing", image: "/assets/leverage/p7.png" },
    { id: 8, title: "Manufacturing", image: "/assets/leverage/p8.png" },
    { id: 9, title: "Manufacturing", image: "/assets/leverage/p9.png" },
    { id: 10, title: "Manufacturing", image: "/assets/leverage/p10.png" },
    { id: 11, title: "Manufacturing", image: "/assets/leverage/p11.png" },
    { id: 12, title: "Manufacturing", image: "/assets/leverage/p12.png" },
];

const IndustriesWeServe = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
        breakpoints: {
            "(min-width: 640px)": {
                slides: { perView: 2, spacing: 20 },
            },
            "(min-width: 1024px)": {
                slides: { perView: 3, spacing: 20 },
            },
            "(min-width: 1280px)": {
                slides: { perView: 4, spacing: 20 },
            },
        },
        slides: { perView: 1.2, spacing: 16 },
    });

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full lg:py-[100px] py-[60px] px-[20px] bg-white overflow-hidden">
            <div className="max-w-[1440px] mx-auto lg:px-[80px] md:px-[40px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={fadeUpVariant}
                    className="flex flex-col md:flex-row md:justify-between md:items-start gap-4 mb-[40px] lg:mb-[60px]"
                >
                    <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Industries We Serve
                    </h2>
                    <p className="font-graphik text-[14px] lg:text-[16px] font-[500] text-[#49577A] max-w-[400px] leading-relaxed">
                        Leveraging deep domain expertise to deliver tailored, future-ready solutions that accelerate digital transformation across diverse sectors.
                    </p>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    variants={fadeUpVariant}
                    className="relative"
                >
                    <div ref={sliderRef} className="keen-slider !overflow-visible lg:!overflow-hidden">
                        {industriesData.map((item) => (
                            <div className="keen-slider__slide" key={item.id}>
                                <div className="relative w-full h-[262px] md:h-[262px] overflow-hidden rounded-sm group cursor-pointer">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-[222px] object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60 pointer-events-none" /> */}

                                    <div className="absolute bottom-[0px] left-[16px] right-[16px] bg-white p-[20px] text-center border border-[#01386A45]">
                                        <h3 className="font-graphik text-[16px] md:text-[20px] font-[500] text-[#01386A] tracking-tight whitespace-nowrap overflow-hidden text-ellipsis">
                                            {item.title}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-[16px] mt-[32px] lg:mt-[40px]">
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] transition-colors hover:bg-[#ED6800] hover:text-white"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                                className="w-[40px] h-[40px] flex items-center justify-center rounded-full border border-[#ED6800] text-[#ED6800] transition-colors hover:bg-[#ED6800] hover:text-white"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </motion.div>

            </div>
        </section>
    );
};

export default IndustriesWeServe;